import { get, put } from '../utils/networking';

export type OrganizationForm = 'AS' | 'ASA' | 'ANS' | 'DA' | 'ENK' | 'SA' | 'STI' | 'NUF' | 'FLI' | 'PUBLIC';

export type HealthServiceAnswer = 'YES' | 'NO' | 'NOT_REQUIRED';

export type BusinessProfile = {
  orgNumber: string;
  legalName: string;
  organizationForm: OrganizationForm | null;
  industryCode: string | null;
  businessAddress: string | null;
  postalCode: string | null;
  postalPlace: string | null;
  employeeCount: number | null;
  ceoName: string;
  ceoEmail: string | null;
  inspectionContactName: string | null;
  inspectionContactRole: string | null;
  inspectionContactEmail: string | null;
  inspectionContactPhone: string | null;
  hasCommittee: boolean | null;
  committeeLeaderName: string | null;
  /** YYYY-MM-DD */
  committeeNextMeeting: string | null;
  healthService: HealthServiceAnswer | null;
  healthServiceName: string | null;
  healthServiceContact: string | null;
};

export type SavedBusinessProfile = {
  orgNumber: string;
  /** fromRegistry: filled from the Central Coordinating Register at sign-up, and not saved by anyone since */
  profile: (BusinessProfile & { updatedAt: string; fromRegistry?: boolean }) | null;
  /** Registered among the safety representatives */
  mainSafetyReps: string[];
};

export type BusinessProfileError =
  | 'orgNumberDigits'
  | 'orgNumberChecksum'
  | 'orgNumberTaken'
  | 'legalName'
  | 'ceoName'
  | 'employeeCount'
  | 'committeeNextMeeting';

/** What the Brønnøysund Register Centre has registered about the business */
export type RegisteredFacts = Pick<
  BusinessProfile,
  'legalName' | 'organizationForm' | 'industryCode' | 'businessAddress' | 'postalCode' | 'postalPlace'
>;

const PATH = '/api/organizations/current/business';

export const getBusinessProfile = () => get<SavedBusinessProfile>(PATH);

export const saveBusinessProfile = (profile: BusinessProfile) => put<void>(PATH, profile);

export const lookUpBusiness = (orgNumber: string) =>
  get<RegisteredFacts>(`${PATH}/registry/${encodeURIComponent(orgNumber)}`);
